/* FlyHugz PageFly ATC shim — the PageFly runtime that used to power ".new-form-atc.addCart"
   buy buttons is no longer loaded, leaving those pages with silently dead Add-To-Cart.
   This rebinds them: find the page's product form / variant select, POST /cart/add.js,
   then open the FlyHugz cart drawer. Safe no-op on pages without these buttons. */
(function () {
  function currentVariantId() {
    // 1) explicit form input
    var idInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (idInput && idInput.value) return idInput.value;
    // 2) PageFly variant select — options carry data-variant-id, or the value IS the id
    var sels = document.querySelectorAll('.pf-product-form select, form[action*="/cart/add"] select');
    for (var i = 0; i < sels.length; i++) {
      var o = sels[i].options[sels[i].selectedIndex];
      if (!o) continue;
      if (o.dataset && o.dataset.variantId) return o.dataset.variantId;
      if (/^\d{10,}$/.test(o.value)) return o.value;
    }
    return null;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('.new-form-atc.addCart, .new-form-atc .addCart');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    if (window.__fhPfAtcBusy) return; window.__fhPfAtcBusy = 1;
    setTimeout(function () { window.__fhPfAtcBusy = 0; }, 4000);
    var vid = currentVariantId();
    if (!vid) { window.__fhPfAtcBusy = 0; window.location.href = '/products/the-original-flyhugz-travel-pillow-2026'; return; }
    btn.style.opacity = '.6';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] })
    }).then(function (r) { return r.json(); }).then(function () {
      btn.style.opacity = '';
      window.__fhPfAtcBusy = 0;
      if (window.fhOpenCart) window.fhOpenCart(); else window.location.href = '/cart';
    }).catch(function () { btn.style.opacity = ''; window.__fhPfAtcBusy = 0; window.location.href = '/cart'; });
  }, true);
})();
